export default __webpack_public_path__ + "static/media/Gebauer-Regular.25106629.otf";